export default __webpack_public_path__ + "static/media/instrukcja-mumu-premium.fa3ea4e8.png";